<template>
  <div>
    <div class="container">
      <!-- <div class="globalTitle">全站新闻</div> -->
      <div class="globalContainer whiteBg">
        <br />
        <!-- 新闻导航 -->
        <div class="scrollDiv">
          <span v-for="(item,index) in globalNewsTagList" :key="index" class="newsTag pointer"
            :class="active==index?'active':''" @click="changeTag(index,item)">{{item.name}}</span>
        </div>
        <div class="whiteBg border" v-loading="loading">
          <div class="flex-between-start">
            <div>
              <div v-for="(item,index) in globalNewsList" :key="index" class="newsContainer" v-if="index<3"
                @click="toDetails(item.nid)">
                <div class="pointer">
                  <h4 class="line1">{{item.title}}</h4>
                  <div class="grey line1">{{item.ctime.split(" ")[0]}}</div>
                  <div class="grey line1">{{item.synopsis}}</div>
                  <br />
                </div>
              </div>
            </div>
            <div>
              <!-- 图片轮播 -->
              <el-carousel height="300px">
                <el-carousel-item v-for="(imgItem,imgIndex) in imgsList" v-if="!empty(imgItem.img)&&imgIndex<3"
                  :key="imgIndex">
                  <img :src="$imgRoot+'/'+imgItem.img" @click="toDetails(imgItem.nid)" width="100%" height="100%" />
                </el-carousel-item>
              </el-carousel>
            </div>
          </div>
          <br />
          <br />
          <div align="center" v-if="globalNewsList.length>3">
            <button class="blackBtn pointer" @click="more()">
              了解更多 ➡
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    data() {
      return {
        active: 0,
        globalNewsTagList: [], //全站新闻导航
        globalNewsList: [], //全站新闻列表
        imgsList: [], //图片列表
        loading: true, //加载状态
        ntid: "", //新闻类型id
        themeName: "", //新闻类型
      }
    },
    mounted() {
      this.getGloablNewsTag();
    },
    methods: {
      //全站新闻标签
      getGloablNewsTag() {
        this.$axios.get("/web/index/news/type").then(res => {
          if (res.code == 0) {
            this.globalNewsTagList = res.data;
            this.getGlobalNewsList(res.data[0]['ntid']);
            this.themeName = res.data[0]['name'];
            // sessionStorage.setItem("ntid", res.data[0]['ntid']);
          }
        });
      },
      //全站新闻列表
      getGlobalNewsList(ntid) {
        function sortNumber(a, b) {
          let a1 = a.img.split("/")[1].split(".")[0];
          let b1 = b.img.split("/")[1].split(".")[0];
          return a1 - b1;
        }
        this.ntid = ntid;
        this.loading = true;
        let data = {
          params: {
            ntid: ntid,
            limit: 4
          }
        };
        if (window.config.MOCK_STATUS) {
          data = {}
        }
        this.$axios.get("/web/index/news/page", data).then(res => {
          if (res.code == 0) {
            this.globalNewsList = res.data.list;
            this.imgsList = res.data.cover.reverse(sortNumber);
            this.loading = false;
          }
        });
      },
      //切换新闻标签
      changeTag(index, item) {
        this.active = index;
        this.themeName = item.name;
        sessionStorage.setItem("ntid", item.ntid);
        this.getGlobalNewsList(item.ntid);
      },
      more() {
        let param = this.encode({
          ntid: this.ntid,
          themeName: this.themeName
        });
        this.goToPage("News", param);
      },
      toDetails(id) {
        let param = this.encode({
          id: id,
          themeName: this.themeName,
          ntid: this.ntid
        });
        this.goToPage("NewsDetail", param);
      }
    }
  }
</script>

<style scoped>
  .scrollDiv {
    overflow-x: auto;
    white-space: nowrap;
  }

  .newsTag {
    display: inline-flex;
    color: white;
    background: rgba(0, 0, 0, 0.5);
    width: 15%;
    justify-content: center;
    align-items: center;
    height: 40px;
    transition: .5s all;
  }

  .newsTag.active,
  .newsTag:hover {
    background: #B41B15;
  }

  .whiteBg {
    padding: 20px;
  }

  .blackLine {
    width: 80px;
    background: #999999;
    height: 2px;
    margin: 5px 0;
  }

  .newsBorder {
    border-right: 2px solid #999999;
  }

  .newsBorder:last-child {
    border: none;
  }

  .line1,
  .line2 {
    line-height: 1.5em;
  }

  .blackBtn {
    background: black;
    color: white;
    padding: 8px 20px;
    border: none;
  }

  .globalContainer {
    padding: 22px;
  }

  .border {
    border: 1px solid #999999;
  }

  .flex-between-start>div {
    width: calc(50% - 40px);
    margin: 0 10px;
  }

  .newsContainer>div,
  .newsContainer>h4 {
    line-height: 1.5em;
  }

  .globalTitle {
    position: absolute;
    background: #B41B15;
    color: white;
    padding: 8px 22px;
    top: -15px;
  }

  .pointer:hover>h4 {
    color: #B41B15;
  }
</style>


// WEBPACK FOOTER //
// src/views/index/components/globalNews.vue